export enum CookieConsentType {
  StrictlyNecessary = 0,
  Preferences = 10,
  Statistics = 20,
  Marketing = 30,
}
